// extracted by mini-css-extract-plugin
export var orderDetails = "_ry-2";
export var orderImage = "_ry-1";
export var orderMeta = "_ry-3";
export var orderSummary = "_ry-0";
export var rightArrow = "_ry-4";